<template>
  <div>
    <title-bar title="设备管理">
      <el-button type="primary" @click="edit()">添加</el-button>
      <el-button type="primary" @click="multiEdit()">批量修改</el-button>
      <el-button type="danger" @click="multiDel">批量删除</el-button>
    </title-bar>
    <div class="page-body">
      <el-form inline>
        <el-form-item>
          <el-checkbox v-model="queryForm.noComp" :label="true">未分配设备</el-checkbox>
        </el-form-item>
        <el-form-item label="设备名称">
          <el-input v-model="queryForm.deviceName" clearable placeholder="请输入设备编码或设备名称"></el-input>
        </el-form-item>
        <el-form-item label="所属单位" v-if="!queryForm.noComp">
          <comp-select v-model="queryForm.compId" @change="query"></comp-select>
        </el-form-item>
        <el-form-item label="告警">
          <code-select v-model="queryForm.warningType" code-type="WARNING_TYPE" @change="query"></code-select>
        </el-form-item>
        <el-form-item label="在线">
          <el-radio v-model="queryForm.online" label="" @change="query">全部</el-radio>
          <el-radio v-model="queryForm.online" :label="true" @change="query">在线</el-radio>
            <el-radio v-model="queryForm.online" :label="false" @change="query">离线</el-radio>
        </el-form-item>
        <el-button type="primary" icon="fa fa-search" :loading="loading" @click="query">查询</el-button>
      </el-form>

      <el-table stripe :data="records" :border="true"
                v-loading="loading"
                @selection-change="handleDeviceSelect"
                @sort-change="handleSortChange">
        <el-table-column type="selection" label="选择" width="40" align="center"></el-table-column>
        <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
        <el-table-column prop="online" label="在线" align="center" width="50" v-slot="{row}">
            <i v-if="row.online" class="fa fa-chain color-success" title="在线"></i>
            <i v-else class="fa fa-chain-broken color-error" title="离线"></i>
        </el-table-column>
        <el-table-column prop="deviceCode" label="设备编号" width="140" sortable="custom" v-slot="{row}">
            <el-link type="primary" @click="showDevice(row)">{{row.deviceCode}}</el-link>
        </el-table-column>
        <el-table-column prop="deviceName" label="设备名称" min-width="150" sortable="custom"></el-table-column>
        <el-table-column prop="address" label="地址" min-width="150" sortable="custom"></el-table-column>
        <el-table-column prop="deviceTypeName" label="类型" align="center" width="60"></el-table-column>
        <el-table-column prop="compName" label="所属单位" min-width="150"></el-table-column>
        <el-table-column prop="kwh" label="电表" align="center" width="60"></el-table-column>
<!--        <el-table-column prop="clothLeftTime" label="无纺布剩余(天)" align="center" width="80">-->
<!--          <template slot-scope="{ row }">-->
<!--            <span v-if="row.clothLeftTime === undefined">-</span>-->
<!--            <span v-else :class="row.clothLeftTime < 30*24 ? 'color-error':''">{{Math.round(row.clothLeftTime/24)}}</span>-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--        <el-table-column prop="lat" label="坐标" align="center" width="60">-->
<!--          <template slot-scope="{ row }">-->
<!--            <el-button v-if="!!row.lat" type="text" icon="fa fa-map-marker" @click="showMap(row)" style="font-size: 16px"></el-button>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column prop="valid" label="启用" align="center" width="60">
          <template slot-scope="{ row }">
            <span v-if="row.valid" class="color-success">启用</span>
            <span v-else class="color-error">禁用</span>
          </template>
        </el-table-column>
        <el-table-column prop="warningInfo" label="告警信息" min-width="200"></el-table-column>
        <el-table-column prop="action" label="操作" width="150" align="center" fixed="right" v-slot="{row}">
            <el-button type="text" icon="fa fa-edit" title="编辑" @click="edit(row)" style="font-size: 16px"></el-button>
            <el-button type="text" icon="fa fa-list" title="运行统计" @click="showDayInfo(row)" style="font-size: 16px"></el-button>
            <el-button type="text" icon="fa fa-upload" title="升级软件" @click="softUpdate(row)"
                       :disabled="!row.online"
                       style="font-size: 16px"></el-button>
            <el-button type="text" icon="fa fa-times-circle color-error" title="删除" @click="del(row.deviceCode)" style="font-size: 16px"></el-button>
        </el-table-column>
      </el-table>
      <table-pagination :page-query="queryForm" :total="total" @change="loadData"></table-pagination>
    </div>

    <map-choose-dialog title="位置查看" :visible.sync="mapVisible"
                       v-if="mapVisible" width="90vw"
                       :lng="device.lng"
                       :lat="device.lat"
                       @close="mapVisible = false"></map-choose-dialog>

    <device-edit-dialog title="设备编辑"
                        :visible.sync="editing"
                        v-if="editing"
                        :device="device"
                        @close="editing=false"
                        @save="onSave"></device-edit-dialog>

    <device-multi-edit-dialog title="设备批量编辑"
                              :visible.sync="multiEditing"
                              v-if="multiEditing"
                              :device="device"
                              @close="multiEditing=false"
                              @save="onSave"></device-multi-edit-dialog>
  </div>
</template>

<script>
import TitleBar from "@/components/base/TitleBar";
import CompSelect from "@/components/base/CompSelect";
import TablePagination from "@/components/base/TablePagination";
import BaseVue from "@/components/base/BaseVue";
import MapChooseDialog from "@/components/base/MapChooseDialog";
import DeviceEditDialog from "@/components/device-view/DeviceEditDialog";
import DeviceMultiEditDialog from "@/components/device-view/DeviceMultiEditDialog";
import CodeSelect from "@/components/base/CodeSelect";
export default {
  name: 'DeviceList',
  components: {
    CodeSelect,
    DeviceMultiEditDialog, DeviceEditDialog, MapChooseDialog, TablePagination, CompSelect, TitleBar},
  extends: BaseVue,
  data() {
    return {
      mapVisible: false,
      editing: false,
      multiEditing: false,
      selectedDevices: [],
      queryForm: {
        noComp: false,
        compId: '',
        deviceName: '',
        online: '',
        page: 1,
        limit: 10,
        //排序
        sortBy: null,
        sortType: null
      },
      total: 0,
      records: [],
      device: null
    }
  },
  created() {
    //重置缓存
    this.queryForm = this.getComponentCache() || this.queryForm;
    this.clearComponentCache();
    this.loadData();
  },
  methods: {
    query(){
      this.queryForm.page = 1;
      this.loadData();
    },
    loadData() {
      this.loading = true;
      this.postForm("/device/v2/getDeviceList", this.queryForm, true).then(dr => {
        this.records = dr.rows;
        this.total = dr.total;
      }).finally(()=>{
        this.loading = false;
      })
    },
    showMap(row){
      this.device = row;
      this.mapVisible = true
    },
    //详情页
    showDevice(device) {
      this.saveCache();
      this.$router.push({
        path: "/deviceView",
        query: {
          deviceCode: device.deviceCode
        }
      });
    },

    edit(row) {
      this.device = Object.assign({
        valid: true,
        deviceType: '1',
        inFanCount: 1,
        outFanCount: 1,
        acCount: 1
      }, row || {});
      this.editing = true;
    },
    multiEdit() {
      if(this.selectedDevices.length == 0) {
        this.$message.info("请选择你要批量修改的设备");
        return;
      }
      let first = this.selectedDevices[0];
      if(this.selectedDevices.length == 1) {
        this.edit(first);
        return;
      }
      this.device = {
        compId: first.compId,
        provCode: first.provCode,
        cityCode: first.cityCode,
        townCode: first.townCode,
        inFanCount: first.inFanCount,
        outFanCount: first.outFanCount,
        acCount: first.acCount,
        acPower: first.acPower,
        valid: true
      }
      let deviceCodes = [];
      this.selectedDevices.forEach(d => {
        deviceCodes.push(d.deviceCode);
      });
      this.device.deviceCode = deviceCodes.join(",");
      this.multiEditing = true;
    },
    onSave(){
      this.editing = false;
      this.query();
    },
    del(deviceCode) {
      this.$confirm("确定要删除“"+deviceCode+"”这些设备吗？","系统提示").then(()=>{
        this.loading = true;
        this.postForm("/device/deleteDevice", {
          deviceCode: deviceCode
        },true).then(()=>{
          this.loadData();
        }).finally(()=>{
          this.loading = false;
        })
      });
    },
    multiDel() {
      let deviceCodes = [];
      this.selectedDevices.forEach(record=>{
        deviceCodes.push(record.deviceCode);
      });
      if(deviceCodes.length == 0) {
        this.$message.warning("请勾选你要删除的设备");
        return;
      }
      this.del(deviceCodes.join(","));
    },
    handleDeviceSelect(data) {
      this.selectedDevices = data;
    },
    handleSortChange({column, prop, order}) {
      if(order == null) {
        this.queryForm.sortBy = null;
        this.queryForm.sortType = null;
      } else {
        this.queryForm.sortBy = prop;
        this.queryForm.sortType = (order === "ascending" ? "asc" : "desc")
      }
      this.query();
    },
    showDayInfo(row) {
      this.saveCache();
      this.$router.push({
        path: "/deviceDayInfo",
        query: {
          deviceCode: row.deviceCode
        }
      })
    },
    softUpdate(row) {
      this.saveCache();
      this.$router.push({
        path: "/deviceUpdate",
        query: {
          deviceCode: row.deviceCode
        }
      })
    },
    saveCache() {
      this.setComponentCache(this.queryForm);
    }
  }
}
</script>

<style scoped>

</style>